import React from "react";
import { Container, Row, Col } from "reactstrap";
import PlaybookTiles from "./Widgets";
import PlaybookGraph from "./IncidentBarGraph";
import IncidentResponseGraph from "./IncidentResponseGraph";
import RecentActivityTable from "./RecentActivity";

const Analytics = () => {
  document.title = "Dashboard | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Row>
             <PlaybookTiles />
           </Row>
         <Row>
  <Col xs={12} md={6}>
    <PlaybookGraph dataColors='["--vz-primary"]' />
  </Col>

  <Col xs={12} md={6}>
    <IncidentResponseGraph />
  </Col>
</Row>

         
        <Row>
            <RecentActivityTable />
        </Row>
          
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Analytics;
